import React, { useState, useContext, useMemo, useEffect, useRef } from "react";
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { StldRow } from "../../../styled-components/StldRow.style";
import { useForm } from 'react-hook-form';
import api from '../../../services/api';
import { StldColumn } from "../../../styled-components/StldColumn.style";
import { MobileContext } from "../../../contexts/MobileContext";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import * as moment from 'moment'
import DatePicker from 'react-datepicker';
import InputMask from "react-input-mask";
import Flex from '@react-css/flex';
import { StyledTablePage } from "../../../styled-components/StyledTablePage.style";
import XLSX from 'sheetjs-style';
import { IconRefresh } from "../../../svg";
import { useTable, useSortBy, useFilters } from "react-table";
import { StyledWipDiarioPage } from "../../../styled-components/StyledWipDiarioPage.style";
import Swal from "sweetalert2";
import { getEmpresas } from '../../../services/empresas';
import { getAreas } from '../../../services/areas';
import { DynamicSelect } from "../../../components/DynamicSelect";
import { Multiselect } from 'multiselect-react-dropdown';

const getLista = async (formValues) => {
    let list = null;
    let params = "";

    if (formValues.startDate) {
        params += `&PeriodoInicial=${moment(formValues.startDate).startOf('day').format('YYYY-MM-DD HH:mm')}`;
    }

    if (formValues.endDate) {
        params += `&PeriodoFinal=${moment(formValues.endDate).endOf('day').format('YYYY-MM-DD HH:mm')}`;
    }

    if (formValues.areas?.length > 0) {
        formValues.areas.forEach(area => {
            params += `&IdAreas=${area.idArea}`;
        });
    }

    try {
        const response = await api.get(`wip/diario?${params}`);
        list = response.data;
        return list;
    } catch (err) {
        return list;
    }
}


export const WIPDiario = () => {
    const [searched, setSearched] = useState(false);
    const [ListaData, setListaData] = useState([]);
    const [horasFaturadas, setHorasFaturadas] = useState([]);
    const [horasProBono, setHorasProBono] = useState([]);
    
    const [recessosData, setRecessosData] = useState([]);
    const [ausenciasData, setAusenciasData] = useState({});
    const [preAdmissoesData, setPreAdmissoesData] = useState({});

    const { register, handleSubmit, reset, getValues } = useForm();
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    var [isLoading, setisLoading] = useState(false);
    const [areaList, setAreaList] = useState([]);
    const [areaDefaultValue, setAreaDefaultValue] = useState([]);
    var [areas, setAreas] = useState([]);
    const multiselectRef = useRef();
    const formSubmit = async (data) => {
        loadTable(data);
    }

    useEffect(() => {
        const asyncFn = async () => {
            const allAreas = await getAreas();
            if (allAreas && allAreas.length > 0) {
                const areasWithAll = [
                    { idArea: -1, description: "Selecionar Todos" }, 
                    ...allAreas
                ];
                setAreaList(areasWithAll);
                setAreaDefaultValue(areasWithAll);
                setAreas(areasWithAll);
            }
        }

        asyncFn();
    }, [null, 0, 10]);


    var [columns, setColumns] = useState([]);
    const formatDecimal = (value) => {
        if (value == null || value === undefined || value === 0) {
            return '0,00';
        }

        return value.toLocaleString('pt-br', { style: 'decimal', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    const betweenFilter = (rows, id, filterValue) => {
        const [min, max] = filterValue;

        return rows.filter(row => {
            const rowValue = row.values[id].replace(".", "").replace(",", ".");

            if (min === undefined && max === undefined) {
                return true;
            }

            return (
                (min === undefined || rowValue >= min) &&
                (max === undefined || rowValue <= max)
            );
        });
    };

    const NumberRangeColumnFilter = ({ column: { filterValue = [], preFilteredRows, setFilter, id }, }) => {
        const [min, max] = useMemo(() => {
            let min = preFilteredRows.length ? parseFloat(preFilteredRows[0].values[id], 10) : 0
            let max = preFilteredRows.length ? parseFloat(preFilteredRows[0].values[id], 10) : 0

            preFilteredRows.forEach(row => {
                min = Math.min(parseFloat(preFilteredRows[0].values[id], 10), min)
                max = Math.max(parseFloat(preFilteredRows[0].values[id], 10), max)
            })

            return [min, max]
        }, [id, preFilteredRows])

        return (
            <div
                style={{
                    display: 'flex',
                }}
            >
                <input
                    value={filterValue[0] || ''}
                    type="number"
                    onChange={e => {
                        const val = e.target.value
                        setFilter((old = []) => [val ? parseFloat(val, 10) : undefined, old[1]])
                    }}
                    placeholder={`Min`}
                    style={{ width: '55px', marginRight: '10px' }}
                />
                <div className="pt-2">Até</div>
                <input
                    value={filterValue[1] || ''}
                    type="number"
                    onChange={e => {
                        const val = e.target.value
                        setFilter((old = []) => [old[0], val ? parseFloat(val, 10) : undefined])
                    }}
                    placeholder={`Max`}
                    style={{ width: '55px', marginLeft: '10px' }}
                />
            </div>
        )
    }

    const isWeekend = (date) => {
        const day = moment(date).day();
        return day === 0 || day === 6;
      }

    const formatColumns = (recessosList = []) => {
        var dataInicial = moment(startDate);
        var dataFinal = moment(endDate);
        var columns = [
            {
                Header: "Profissional",
                accessor: "nome",
                className: "text-center  font-weight-bold",
                classNameFooter: "text-center font-wip-diario font-weight-bold",
                type: "String",
                classnameHeader: "text-center",
                inputFilterClass: "150",
                Footer: info => {
                    return <> Total Geral </>
                },
                wch: 20
            },
            {
                Header: "Área",
                accessor: "nomeArea",
                className: "text-center  font-weight-bold",
                classNameFooter: "text-center font-wip-diario font-weight-bold",
                type: "String",
                classnameHeader: "text-center",
                inputFilterClass: "150",
                Footer: info => {
                    return <>  </>
                },
                wch: 20
            }
        ]      
        
        columns.push(
            {
                Header: "Total Geral",
                accessor: "totalGeral",
                className: "text-center font-wip-diario font-weight-bold",
                classNameFooter: "text-center font-wip-diario font-weight-bold",
                type: "String",
                classnameHeader: "text-center width-50",
                inputFilterClass: "50",
                wch: 12,
                Footer: info => {
                    const total = React.useMemo(
                        () =>
                            info.rows.reduce((sum, row) => (row.original[info.column.id] != undefined ? parseFloat(row.original[info.column.id].replace(".", "").replace(",", ".")) : 0 ) + sum, 0),
                        [info.rows]
                    )
                    return <span className="text-center"> {formatDecimal(total)}</span>
                },
            },
            {
                Header: "Média Diária",
                accessor: "mediaDiaria",
                className: "text-center",
                classNameFooter: "text-center",
                type: "Number",
                classnameHeader: "text-center width-50",
                inputFilterClass: "50",
                wch: 12,
                filter: 'between',
                Filter: NumberRangeColumnFilter,
                Footer: info => {
                    const total = React.useMemo(
                        () =>
                            info.rows.reduce((sum, row) => (row.original[info.column.id] != undefined ? parseFloat(row.original[info.column.id].replace(".", "").replace(",", ".")) : 0 ) + sum, 0),
                        [info.rows]
                    )
                    return <> {formatDecimal(total)}</>
                },
            }
        );

        while (dataInicial.isSameOrBefore(dataFinal)) {
            let classnameHeader = "text-center";

            let isFeriado = recessosList.some(r => r.data === dataInicial.format('DDMMYYYY'));

            if(isWeekend(dataInicial) || isFeriado)
                classnameHeader += " wekeend-days"

            columns.push({
                Header: dataInicial.format('DD/MM'),
                accessor: dataInicial.format('DDMMYYYY'),
                className: "text-center text-bold",
                type: "Number",
                inputFilterClass: "30",
                classnameHeader: classnameHeader,
                wch: 5,
                Footer: info => {
                    const total = React.useMemo(
                        () =>
                            info.rows.reduce((sum, row) => (row.original[info.column.id] != undefined ? parseFloat(row.original[info.column.id].replace(",", ".")) : 0 ) + sum, 0),
                        [info.rows]
                    )
                    return <div className="text-center font-wip-diario"> {formatDecimal(total)}</div>
                },
            })
            dataInicial.add(1, 'days');
        }

        setColumns(columns)
    }

    const loadTable = async (data) => {
        if(!startDate) { Swal.fire({ title: "Atenção", text: "Informe a data de início", icon: "error", confirmButtonText: "OK", }); return }
        if(!endDate) { Swal.fire({ title: "Atenção", text: "Informe a data final", icon: "error", confirmButtonText: "OK", }); return }
        if(!areas || areas.length === 0) { Swal.fire({ title: "Atenção", text: "Informe a área", icon: "error", confirmButtonText: "OK", }); return }
        
        let formValues = { startDate: startDate, endDate: endDate, areas: areas };

        setisLoading(true)
        const result = await getLista(formValues);
        formatColumns(result?.data?.recessos || [])

        setListaData(result?.data?.lancamentos);
        setSearched(true)
        setHorasFaturadas(result?.data?.faturadas);
        setHorasProBono(result?.data?.proBono);
        
        setRecessosData(result?.data?.recessos || []);
        setAusenciasData(result?.data?.ausencias || {});
        setPreAdmissoesData(result?.data?.preAdmissoes || {});

        setisLoading(false)
    }

    const [startDate, setStartDate] = useState(null);
    const handleStartDateChange = (date) => { setStartDate(date); }

    const [endDate, setEndtDate] = useState(null);
    const handleEndDateChange = (date) => { setEndtDate(date); }

    const formatNumberValue = (value) => {
        if (null === value || undefined === value || '' === value) return "";
        if (typeof value === 'number') return value;
        value = value.replace(/(\.)/g, '').replace('-', '').replace('R$', '').replace(',', '.');
        return isNaN(value) ? "" : parseFloat(value);
    }

    const exportExcel = () => {
        if (ListaData?.length === 0) {
            return;
        }
        var dataFinal = moment(endDate);
        const cols = []
        const xlsxData = []
        const fill = {
            font: {
                bold: true,
                color: { rgb: "FFFFFF" }
            },
            fill: {
                type: 'pattern',
                patternType: 'solid',
                fgColor: { rgb: "000080" },
            },
        };

        const redFill = {
            font: {
                bold: true,
                color: { rgb: "000000" }
            },
            fill: {
                type: 'pattern',
                patternType: 'solid',
                fgColor: { rgb: "ee828c" },
            },
        };

        const yellowFill = {
            font: {
                bold: true,
                color: { rgb: "000000" }
            },
            fill: {
                type: 'pattern',
                patternType: 'solid',
                fgColor: { rgb: "ffff99" },
            },
        };

        const yellowFillOutDays = {
            font: {
                bold: true,
                color: { rgb: "000000" }
            },
            fill: {
                type: 'pattern',
                patternType: 'solid',
                fgColor: { rgb: "0d6efd" },
            },
        };

        const greenFill = {
            font: {
                bold: true,
                color: { rgb: "000000" }
            },
            fill: {
                type: 'pattern',
                patternType: 'solid',
                fgColor: { rgb: "b5e6a2" },
            },
        };

        const recessoFill = {
            font: {
                bold: true,
                color: { rgb: "000000" }
            },
            fill: {
                type: 'pattern',
                patternType: 'solid',
                fgColor: { rgb: "CDCCD7" },
            },
        };

        const feriasFill = {
            font: {
                bold: true,
                color: { rgb: "000000" }
            },
            fill: {
                type: 'pattern',
                patternType: 'solid',
                fgColor: { rgb: "F2A057" },
            },
        };

        ListaData?.reverse().map(wip => {
            var dataInicial = moment(startDate);
            var data = {
                Profissional: wip.nome,
                'Área': wip.nomeArea
            }
            while (dataInicial.isSameOrBefore(dataFinal)) {
                data[dataInicial.format('DD/MM')] = formatNumberValue(wip[dataInicial.format('DDMMYYYY')] || '');
                dataInicial.add(1, 'days');
            }
            data['Total Geral'] = formatNumberValue(wip.totalGeral);
            data['Média Diária'] = formatNumberValue(wip.mediaDiaria);
            xlsxData.push(data)
        })

        var dataInicial = moment(startDate);
        var data = {
            Profissional: "Total Geral",
            'Área': ""
        }

        while (dataInicial.isSameOrBefore(dataFinal)) {
            var total = 0;
            ListaData.map(wip => {
                if(wip[dataInicial.format('DDMMYYYY')])
                    total += parseFloat(wip[dataInicial.format('DDMMYYYY')].replace(".", "").replace(",", "."))
            })
            data[dataInicial.format('DD/MM')] = formatNumberValue(formatDecimal(total));
            dataInicial.add(1, 'days');
        }
        var totalGeral = ListaData.reduce((sum, item) => sum + parseFloat(item.totalGeral.replace(".", "").replace(",", ".")), 0);
        data['Total Geral'] = formatNumberValue(formatDecimal(totalGeral));
        var dataInicial = moment(startDate);

        const totalMedia = ListaData.reduce((sum, row) => (row.mediaDiaria != undefined ? parseFloat(row.mediaDiaria.replace(".", "").replace(",", ".")) : 0 ) + sum, 0);
        data['Média Diária'] = formatNumberValue(totalMedia);

        xlsxData.push(data)

        //horas faturadas
        if(horasFaturadas) {
            var dataInicial = moment(startDate);
            var data = {
                Profissional: horasFaturadas.nome,
                'Área': ""
            }
            while (dataInicial.isSameOrBefore(dataFinal)) {
                data[dataInicial.format('DD/MM')] = formatNumberValue(horasFaturadas[dataInicial.format('DDMMYYYY')] ? parseFloat(horasFaturadas[dataInicial.format('DDMMYYYY')].replace(".", "").replace(",", ".")) : 0);
                dataInicial.add(1, 'days');
            }
            data['Média Diária'] = formatNumberValue(horasFaturadas.mediaDiaria);
            data['Total Geral'] = formatNumberValue(horasFaturadas.totalGeral);

            xlsxData.push(data)
        }

        //variação
        var data = {
            Profissional: "Variação",
            'Área': ""
            
        }
        var dataInicial = moment(startDate);

        while (dataInicial.isSameOrBefore(dataFinal)) {
            var dataLancamento = dataInicial.format('DDMMYYYY')
            let toHorasFaturadas = horasFaturadas[dataLancamento] ?  parseFloat(horasFaturadas[dataLancamento].replace(".", "").replace(",", ".")) : 0; 
            const total = ListaData.reduce((sum, row) => (row[dataLancamento] != undefined ? parseFloat(row[dataLancamento].replace(".", "").replace(",", ".")) : 0 ) + sum, 0)

            data[dataInicial.format('DD/MM')] = formatNumberValue(total - toHorasFaturadas);
            dataInicial.add(1, 'days');
        }

        const tGeral = xlsxData.filter(x=> x.Profissional == "Total Geral")[0];
        const hoFaturadas = xlsxData.filter(x=> x.Profissional == "Horas Faturadas")[0];

        data['Total Geral'] = formatNumberValue(tGeral['Total Geral'] - hoFaturadas["Total Geral"])
        data['Média Diária'] = formatNumberValue(tGeral["Média Diária"] - hoFaturadas["Média Diária"])
        xlsxData.push(data)

        //horas pro bono
        if(horasProBono) {
            var dataInicial = moment(startDate);
            var data = {
                Profissional: horasProBono.nome,
                'Área': ""
            }
            while (dataInicial.isSameOrBefore(dataFinal)) {
                data[dataInicial.format('DD/MM')] = formatNumberValue(horasProBono[dataInicial.format('DDMMYYYY')] ? parseFloat(horasProBono[dataInicial.format('DDMMYYYY')].replace(".", "").replace(",", ".")) : 0);
                dataInicial.add(1, 'days');
            }
            data['Média Diária'] = formatNumberValue(horasProBono.mediaDiaria);
            data['Total Geral'] = formatNumberValue(horasProBono.totalGeral);

            xlsxData.push(data)
        }

        const worksheet = XLSX.utils.json_to_sheet(xlsxData);
        const range = XLSX.utils.decode_range(worksheet["!ref"]);

        for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
            if (!worksheet[cellAddress]) continue;

            worksheet[cellAddress].s = {
                font: {
                    bold: true,
                    color: { rgb: "FFFFFF" }, // Texto branco
                },
                fill: {
                    fgColor: { rgb: "EE4B21" }, // Fundo azul
                },
                border: {
                    top: { style: "thin", color: { rgb: "000000" } },
                    bottom: { style: "thin", color: { rgb: "000000" } },
                    left: { style: "thin", color: { rgb: "000000" } },
                    right: { style: "thin", color: { rgb: "000000" } },
                },
                alignment: {
                    horizontal: "center",
                    vertical: "center", 
                },
            };
        }

        for (let row = 1; row <= range.e.r - 4; row++) {
            for (let col = 0; col <= range.e.c; col++) {
                const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
                if (!worksheet[cellAddress]) continue;

                worksheet[cellAddress].s = {
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } },
                        bottom: { style: "thin", color: { rgb: "000000" } },
                        left: { style: "thin", color: { rgb: "000000" } },
                        right: { style: "thin", color: { rgb: "000000" } },
                    },
                    alignment: {
                        horizontal: "center",
                        vertical: "center", 
                    },
                };
            }
        }

        for (let i = 0; i < columns.length; i++) {
            var headerColumn = getExcelColumnLabel(i+1)+"1"

            if(worksheet[headerColumn]) {
                worksheet[headerColumn].s = fill;

                var totalColumn = getExcelColumnLabel(i+1) + (ListaData.length + 2)
                worksheet[totalColumn].s = fill;

                var horasColumn = getExcelColumnLabel(i+1) + (ListaData.length + 3)
                worksheet[horasColumn].s = fill;
                
                var variacaoColumn = getExcelColumnLabel(i+1) + (ListaData.length + 4)
                worksheet[variacaoColumn].s = fill;

                var probonoColumn = getExcelColumnLabel(i+1) + (ListaData.length + 5)
                worksheet[probonoColumn].s = fill;
            }

            cols.push({ wch: columns[i].wch });
        }

        for (let i = 1; i < columns.length; i++) {
            if(columns[i]['Header'] != "Total Geral" && columns[i]['Header'] != "Área") {

                if(columns[i]['Header'] != "Média Diária") {
                    var dat = moment(columns[i].accessor, "DDMMYYYY")

                    let isFeriado = recessosData?.some(r => r.data === columns[i].accessor);

                    if(isWeekend(dat) || isFeriado) {
                        var cell = getExcelColumnLabel(i+1)+"1"
                        worksheet[cell].s = {
                            font: {
                                bold: true,
                                color: { rgb: "FFFFFF" }, // Texto branco
                            },
                            fill:
                            {
                                fgColor: { rgb: "0d6efd" }, // Fundo azulclaro (fime de semana)
                            },
                            border: {
                                top: { style: "thin", color: { rgb: "000000" } },
                                bottom: { style: "thin", color: { rgb: "000000" } },
                                left: { style: "thin", color: { rgb: "000000" } },
                                right: { style: "thin", color: { rgb: "000000" } },
                            },
                            alignment: {
                                horizontal: "center",
                                vertical: "center", 
                            },
                        };
                    }
                }

                for (let row = 1; row <= ListaData.length; row++) {
                    var cell = getExcelColumnLabel(i+1)+(row+1)

                    if (!worksheet[cell]) {
                        worksheet[cell] = { t: 's', v: '' };
                    }

                    let colId = columns[i].accessor;
                    let profName = ListaData[row - 1].nome;
                    let isRecesso = colId !== "mediaDiaria" && recessosData?.some(r => r.data === colId);
                    let isAusencia = colId !== "mediaDiaria" && ausenciasData[profName]?.some(a => a.data === colId);
                    let isFimDeSemana = colId !== "mediaDiaria" && colId !== "nome" && colId !== "nomeArea" && colId !== "totalGeral" && isWeekend(moment(colId, "DDMMYYYY"));
    
                    if (isRecesso) {
                        worksheet[cell].s = {
                            font: { bold: false, color: { rgb: "000000" } },
                            fill: { type: 'pattern', patternType: 'solid', fgColor: { rgb: "CDCCD7" } },
                            border: {
                                top: { style: "thin", color: { rgb: "000000" } },
                                bottom: { style: "thin", color: { rgb: "000000" } },
                                left: { style: "thin", color: { rgb: "000000" } },
                                right: { style: "thin", color: { rgb: "000000" } },
                            },
                            alignment: { horizontal: "center", vertical: "center" },
                        };
                    } else if (isAusencia) {
                        worksheet[cell].s = {
                            font: { bold: false, color: { rgb: "000000" } },
                            fill: { type: 'pattern', patternType: 'solid', fgColor: { rgb: "F2A057" } },
                            border: {
                                top: { style: "thin", color: { rgb: "000000" } },
                                bottom: { style: "thin", color: { rgb: "000000" } },
                                left: { style: "thin", color: { rgb: "000000" } },
                                right: { style: "thin", color: { rgb: "000000" } },
                            },
                            alignment: { horizontal: "center", vertical: "center" },
                        };
                    } else if (isFimDeSemana) {
                        worksheet[cell].s = {
                            font: { bold: false, color: { rgb: "000000" } },
                            fill: { type: 'pattern', patternType: 'solid', fgColor: { rgb: "CDCCD7" } },
                            border: {
                                top: { style: "thin", color: { rgb: "000000" } },
                                bottom: { style: "thin", color: { rgb: "000000" } },
                                left: { style: "thin", color: { rgb: "000000" } },
                                right: { style: "thin", color: { rgb: "000000" } },
                            },
                            alignment: { horizontal: "center", vertical: "center" },
                        };
                    } else {
                        if(!worksheet[cell].v || worksheet[cell].v == "") {
                            worksheet[cell].s = {
                                fill: { type: 'pattern', patternType: 'solid', fgColor: { rgb: "e1b7bb" } },
                                border: {
                                    top: { style: "thin", color: { rgb: "000000" } },
                                    bottom: { style: "thin", color: { rgb: "000000" } },
                                    left: { style: "thin", color: { rgb: "000000" } },
                                    right: { style: "thin", color: { rgb: "000000" } },
                                },
                                alignment: { horizontal: "center", vertical: "center" },
                            };
                        }
                        else {
                            if(worksheet[cell].v > 8) {
                                worksheet[cell].s = {
                                    fill: { type: 'pattern', patternType: 'solid', fgColor: { rgb: "b5e6a2" } },
                                    border: {
                                        top: { style: "thin", color: { rgb: "000000" } },
                                        bottom: { style: "thin", color: { rgb: "000000" } },
                                        left: { style: "thin", color: { rgb: "000000" } },
                                        right: { style: "thin", color: { rgb: "000000" } },
                                    },
                                    alignment: { horizontal: "center", vertical: "center" },
                                };
                            }
                            else if(worksheet[cell].v >= 7 && worksheet[cell].v <= 8){
                                worksheet[cell].s = {
                                    fill: { type: 'pattern', patternType: 'solid', fgColor: { rgb: "ffff99" } },
                                    border: {
                                        top: { style: "thin", color: { rgb: "000000" } },
                                        bottom: { style: "thin", color: { rgb: "000000" } },
                                        left: { style: "thin", color: { rgb: "000000" } },
                                        right: { style: "thin", color: { rgb: "000000" } },
                                    },
                                    alignment: { horizontal: "center", vertical: "center" },
                                };
                            }
                            else {
                                worksheet[cell].s = {
                                    fill: { type: 'pattern', patternType: 'solid', fgColor: { rgb: "e1b7bb" } },
                                    border: {
                                        top: { style: "thin", color: { rgb: "000000" } },
                                        bottom: { style: "thin", color: { rgb: "000000" } },
                                        left: { style: "thin", color: { rgb: "000000" } },
                                        right: { style: "thin", color: { rgb: "000000" } },
                                    },
                                    alignment: { horizontal: "center", vertical: "center" },
                                };
                            }
                        }
                    }
                }
            }
        }        
        
        // ====================================================================
        // APLICAR FORMATAÇÃO NUMÉRICA
        // ====================================================================
        
        let colTotalGeral = -1;
        let colMediaDiaria = -1;

        for (let c = 0; c <= range.e.c; c++) {
            let headerCell = worksheet[XLSX.utils.encode_cell({ r: 0, c: c })];
            if (headerCell) {
                if (headerCell.v === 'Total Geral') colTotalGeral = c;
                if (headerCell.v === 'Média Diária') colMediaDiaria = c;
            }
        }

        for (let r = 1; r <= range.e.r; r++) { 
            [colTotalGeral, colMediaDiaria].forEach(c => {
                if (c === -1) return; 
                
                const cellAddress = XLSX.utils.encode_cell({ r: r, c: c });
                const cell = worksheet[cellAddress];

                if (cell && cell.v !== undefined && cell.v !== "") {
                    let numericValue;
                    
                    // SE JÁ FOR NÚMERO (como os totais do rodapé), não faz replace
                    if (typeof cell.v === 'number') {
                        numericValue = cell.v;
                    } 
                    // SE FOR TEXTO (como "1.200,50"), limpa a máscara do pt-BR
                    else {
                        let strVal = String(cell.v);
                        numericValue = parseFloat(strVal.replace(/\./g, "").replace(",", "."));
                    }

                    if (!isNaN(numericValue)) {
                        worksheet[cellAddress].v = numericValue; 
                        worksheet[cellAddress].t = 'n';          
                        worksheet[cellAddress].z = "#,##0.00";   
                    }
                }
            });
        }
        // ====================================================================

        worksheet['!cols'] = cols;

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "ExportDB");

        XLSX.writeFile(workbook, `WIP_${moment().format('DD-MM-YYYY HH:mm:ss')}.xlsx` );
    }

    const getExcelColumnLabel = (n) => {
        let label = '';
        while (n > 0) {
            let remainder = (n - 1) % 26;
            label = String.fromCharCode(65 + remainder) + label;
            n = Math.floor((n - 1) / 26);
        }
        return label;
    }
    const refreshData = async () => { loadTable({ startDate, endDate, areas }); };
    const filterTypes = { text: (rows, id, filterValue) => rows.filter(row => { const rowValue = row.values[id]; return rowValue !== undefined ? String(rowValue).toLowerCase().startsWith(String(filterValue).toLowerCase()) : true; }), between: betweenFilter };
    const ColumnFilter = ({ column }) => { const { filterValue, setFilter, inputFilterClass } = column; return <input value={filterValue || ""} onChange={e => setFilter(e.target.value || undefined)} placeholder={`Filtrar`} className={`width-${inputFilterClass}`} />; };
    const onGetArea = (selectedList, selectedItem) => { if (selectedItem.idArea === -1) { setAreaDefaultValue(areaList); setAreas(areaList); } else { if (selectedList.length === areaList.length - 1) { setAreaDefaultValue(areaList); setAreas(areaList); } else { setAreaDefaultValue(selectedList); setAreas(selectedList); } } };
    const onRemoveArea = (selectedList, removedItem) => { if (removedItem.idArea === -1) { setAreaDefaultValue([]); setAreas([]); } else { const newList = selectedList.filter(item => item.idArea !== -1); setAreaDefaultValue(newList); setAreas(newList); } }

    const sortees = useMemo(() => [{ id: "Profissional", asc: true }], []);
    const defaultColumn = { Filter: ColumnFilter };
    const { getTableProps, getTableBodyProps, headerGroups, footerGroups, rows, prepareRow } = useTable({ columns, data: ListaData, defaultColumn, filterTypes, initialState: { sortBy: sortees } }, useFilters, useSortBy);

    return (
        <section>
            <main className="d-flex">
                {isDesktop && <Menu></Menu>}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header">WIP Diário</h5>
                            <span title="Atualizar" className="cursorPointer" onClick={refreshData}><IconRefresh color={"#EE4B21"} /></span>
                        </div>
                    </div>
                    <div className="card timesheet">
                        <StyledForm onSubmit={handleSubmit(formSubmit)} style={{ marginBottom: "-40px", paddingBottom: "0", zIndex: 8999 }}>
                            <div className='form-wrapper filter-container'>
                                <div className="position-relative col-sm-12 col-md-12 col-lg-12 pt-0 pl-0">
                                    <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 pl-0" style={{ float: 'left' }}>
                                        <DatePicker dateFormat="dd/MM/yyyy" locale="pt-BR" className="input-form" selected={startDate} onChange={handleStartDateChange} placeholderText={'Data de início'} customInput={<InputMask mask="99/99/9999" className="input-form py-2" style={{ width: '100%' }} />} />
                                    </div>
                                    <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 pl-0" style={{ float: 'left' }}>
                                        <DatePicker dateFormat="dd/MM/yyyy" locale="pt-BR" className="input-form" selected={endDate} onChange={handleEndDateChange} placeholderText={'Data final'} customInput={<InputMask mask="99/99/9999" className="input-form py-2" style={{ width: '100%' }} />} />
                                    </div>
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12 p-0">
                                    <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12 pl-0" style={{ float: 'left' }}>
                                        <Multiselect className="searchWrapperCustom" placeholder={'Selecione a Área'} showCheckbox={true} isObject={true} options={areaList} selectedValues={areaDefaultValue} onSelect={onGetArea} onRemove={onRemoveArea} displayValue="description" ref={multiselectRef} showArrow={true} />
                                    </div>
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12 p-2">
                                    <input type="submit" className='default-button-red' value='Pesquisar' />
                                    {ListaData?.length > 0 && <input type="button" className='default-button-red ml-3' value='Exportar' onClick={exportExcel} />}

                                    <div className="position-relative form-group col-12 pl-0" style={{ float: 'right', width: "600px", marginTop: "-10px" }}>
                                        <table className="table table-bordered table-sm">
                                            <thead>
                                                <tr>
                                                    <th className="text-left font-weight-bold" colSpan={5} style={{ fontSize: "11px"}}>Legenda</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="text-center" style={{ backgroundColor: "#b5e6a2", fontSize: "12px"}}>Acima de 8h</td>
                                                    <td className="text-center" style={{ backgroundColor: "#ffff99", fontSize: "12px"}}>Entre 7h e 8h</td>
                                                    <td className="text-center" style={{ backgroundColor: "#e1b7bb", fontSize: "12px"}}>Abaixo de 7h</td>
                                                    <td className="text-center" style={{ backgroundColor: "#CDCCD7", fontSize: "12px"}}>Recessos</td>
                                                    <td className="text-center" style={{ backgroundColor: "#F2A057", fontSize: "12px"}}>Férias / Ausências</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </StyledForm>
                        <StldRow>
                            <Flex>
                                {isLoading ?
                                    <div className="text-center"><div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status"></div><div><strong style={{ color: "#EE4B21" }}>Pesquisando...</strong></div></div> : (
                                        <StyledWipDiarioPage>
                                            <div className="timesheet">
                                                <StyledTablePage>
                                                    {ListaData != null && ListaData?.length > 0 ? (
                                                        <div className="table-container" style={{border: "1px solid #000"}}>
                                                            <table {...getTableProps()} className="table table-bordered wip-diario table-width table-sm">
                                                                <thead style={{ zIndex: 7999 }}>
                                                                    {headerGroups.map((headerGroup) => (
                                                                        <>
                                                                            <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                                                                                {headerGroup.headers.map((column) => <th {...column.getHeaderProps(column.getSortByToggleProps())} className={`${column?.classnameHeader}`}>{column.render("Header")}</th>)}
                                                                            </tr>
                                                                            <tr {...headerGroup.getHeaderGroupProps()}>{headerGroup.headers.map((column) => <th className={`${column?.classnameHeader}`}><div>{column.canFilter ? column.render("Filter") : null}</div></th>)}</tr>
                                                                        </>
                                                                    ))}
                                                                </thead>
                                                                <tbody {...getTableBodyProps()}>
                                                                    {rows.map((row) => {
                                                                        prepareRow(row);
                                                                        return (
                                                                            <tr {...row.getRowProps()} className={`table-data-info`}>
                                                                                {row.cells.map((cell, i) => {
                                                                                    let className = "";
                                                                                    let colId = cell.column.id;
                                                                                    let profName = row.original.nome;
                                                                                    
                                                                                    let recObj = recessosData?.find(r => r.data === colId);
                                                                                    let ausObj = ausenciasData[profName]?.find(a => a.data === colId);
                                                                                    let preAdmObj = preAdmissoesData[profName]?.find(p => p.data === colId);

                                                                                    let isRecesso = colId !== "mediaDiaria" && colId !== "nome" && colId !== "nomeArea" && colId !== "totalGeral" && recObj;
                                                                                    let isAusencia = colId !== "mediaDiaria" && colId !== "nome" && colId !== "nomeArea" && colId !== "totalGeral" && ausObj;
                                                                                    let isPreAdmissoes = colId !== "mediaDiaria" && colId !== "nome" && colId !== "nomeArea" && colId !== "totalGeral" && preAdmObj;
                                                                                    let isFimDeSemana = colId !== "mediaDiaria" && colId !== "nome" && colId !== "nomeArea" && colId !== "totalGeral" && isWeekend(moment(colId, "DDMMYYYY"));

                                                                                    if(cell.column.type === 'Number') {
                                                                                        if (isRecesso) className = "recessoCell";
                                                                                        else if (isAusencia) className = "feriasCell";
                                                                                        else if (isPreAdmissoes) className = "preAdmissoesCell";
                                                                                        else if (isFimDeSemana) className = "recessoCell";
                                                                                        else {
                                                                                            let v = row.original[colId] ? parseFloat(row.original[colId].replace(",", ".")) : 0;
                                                                                            className = v > 8 ? "greenCell" : (v >= 7 ? "yellowCell" : "redCell");
                                                                                        }
                                                                                    }

                                                                                    // Organizando o texto do tooltip
                                                                                    let tooltipText = "";
                                                                                    if (isRecesso) tooltipText = recObj?.motivo || "";
                                                                                    if (isAusencia) tooltipText = ausObj?.motivo || "";
                                                                                    if (isPreAdmissoes) tooltipText = preAdmObj?.motivo || "";
                                                                                    if (isFimDeSemana) tooltipText = "Fim de Semana";

                                                                                    return (
                                                                                        isRecesso || isAusencia || isFimDeSemana || isPreAdmissoes ? (
                                                                                            <td {...cell.getCellProps()} className={`${cell.column.className} ${className} has-tooltip`} data-tooltip={tooltipText == 'Atestado Médico' ? 'Ausente' : tooltipText}>
                                                                                                <div className={`${(row?.cells[i].column?.tag && 'badge badge-secondary')}`}>
                                                                                                    {cell.render("Cell")}
                                                                                                </div>
                                                                                            </td>
                                                                                        )
                                                                                        :
                                                                                        (
                                                                                            <td {...cell.getCellProps()} className={`${cell.column.className} ${className}`}>
                                                                                                <div className={`${(row?.cells[i].column?.tag && 'badge badge-secondary')}`}>
                                                                                                    {cell.render("Cell")}
                                                                                                </div>
                                                                                            </td>
                                                                                        )
                                                                                    );
                                                                                })}
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                </tbody>
                                                                <tfoot>
                                                                    {footerGroups.map((footerGroup) => (
                                                                        <>
                                                                            {/* 1. TOTAL GERAL (Já vem renderizado da definição das colunas) */}
                                                                            <tr {...footerGroup.getFooterGroupProps()}>
                                                                                {footerGroup.headers.map((cell) => cell.accessor && (
                                                                                    <th className={`${cell?.classNameFooter}`}>
                                                                                        {cell.Footer && cell.render('Footer')}
                                                                                    </th>
                                                                                ))}
                                                                            </tr>

                                                                            {/* 2. HORAS FATURADAS */}
                                                                            <tr {...footerGroup.getFooterGroupProps()}>
                                                                                {footerGroup.headers.map((cell) => {
                                                                                    if (!cell.accessor) return null;
                                                                                    if (cell.id === "nome") return <th className={`${cell?.classNameFooter} text-center`}>Horas Faturadas</th>;
                                                                                    if (cell.id === "nomeArea") return <th className={`${cell?.classNameFooter} text-center`}></th>;
                                                                                    
                                                                                    const valorFaturado = horasFaturadas[cell.id] 
                                                                                        ? parseFloat(String(horasFaturadas[cell.id]).replace(".", "").replace(",", ".")) 
                                                                                        : 0;

                                                                                    return <th className={`${cell?.classNameFooter} text-center`}>{formatDecimal(valorFaturado)}</th>;
                                                                                })}
                                                                            </tr>

                                                                            {/* 3. VARIAÇÃO (Total Geral - Horas Faturadas) */}
                                                                            <tr {...footerGroup.getFooterGroupProps()}>
                                                                                {footerGroup.headers.map((cell) => {
                                                                                    if (!cell.accessor) return null;
                                                                                    if (cell.id === "nome") return <th className={`${cell?.classNameFooter} text-center`}>Variação</th>;
                                                                                    if (cell.id === "nomeArea") return <th className={`${cell?.classNameFooter} text-center`}></th>;
                                                                                    
                                                                                    // Soma o Total Geral da coluna atual direto das linhas renderizadas (rows)
                                                                                    const totalGeralCol = rows.reduce((sum, row) => {
                                                                                        const val = row.original[cell.id];
                                                                                        return sum + (val !== undefined && val !== null ? parseFloat(String(val).replace(".", "").replace(",", ".")) : 0);
                                                                                    }, 0);

                                                                                    // Pega o valor de Horas Faturadas da coluna atual
                                                                                    const faturadaCol = horasFaturadas[cell.id] 
                                                                                        ? parseFloat(String(horasFaturadas[cell.id]).replace(".", "").replace(",", ".")) 
                                                                                        : 0;

                                                                                    const variacao = totalGeralCol - faturadaCol;

                                                                                    return <th className={`${cell?.classNameFooter} text-center`}>{formatDecimal(variacao)}</th>;
                                                                                })}
                                                                            </tr>

                                                                            {/* 4. PRO BONO */}
                                                                            <tr {...footerGroup.getFooterGroupProps()}>
                                                                                {footerGroup.headers.map((cell) => {
                                                                                    if (!cell.accessor) return null;
                                                                                    if (cell.id === "nome") return <th className={`${cell?.classNameFooter} text-center`}>Pro Bono</th>;
                                                                                    if (cell.id === "nomeArea") return <th className={`${cell?.classNameFooter} text-center`}></th>;
                                                                                    
                                                                                    const valorProBono = horasProBono[cell.id] 
                                                                                        ? parseFloat(String(horasProBono[cell.id]).replace(".", "").replace(",", ".")) 
                                                                                        : 0;

                                                                                    return <th className={`${cell?.classNameFooter} text-center`}>{formatDecimal(valorProBono)}</th>;
                                                                                })}
                                                                            </tr>
                                                                        </>
                                                                    ))}
                                                                </tfoot>
                                                            </table>
                                                        </div>
                                                    ) : (
                                                        ListaData?.length == 0 && searched && <StldColumn xs="12"><div className="alert alert-warning">Atenção! Nenhum resultado encontrado!</div></StldColumn>
                                                    )}
                                                </StyledTablePage>
                                            </div>
                                        </StyledWipDiarioPage>
                                    )
                                }
                            </Flex>
                        </StldRow>
                    </div>
                </StyledDefaultPage>
            </main>
        </section>
    );
};

export const WIPDiarioPage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? <MenuPage isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} /> : (
                <>
                    <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
                    <WIPDiario />
                </>
            )}
        </>
    );
};